import { useCallback } from 'react';

import { useSetAtom } from 'jotai';

import { pollsAtom } from './pollsAtom';
import { PollStatus } from './types';
import type { Poll, PollType } from './types';
import { clearPollToastTracking } from './useGlobalPolling';

export interface StartPollOptions<TMeta = Record<string, unknown>> {
  id: string;
  type: PollType;
  metadata?: TMeta;
  preserveHistory?: boolean;
}

export function useStartPoll() {
  const dispatch = useSetAtom(pollsAtom);

  const startPoll = useCallback(
    <TMeta extends Record<string, unknown> = Record<string, unknown>>(
      options: StartPollOptions<TMeta>
    ) => {
      clearPollToastTracking(options.id);

      const now = Date.now();
      const poll: Omit<Poll, 'pollCount'> = {
        id: options.id,
        type: options.type,
        metadata: (options.metadata || {}) as Record<string, unknown>,
        startedAt: now,
        lastPolledAt: now,
        status: PollStatus.Pending,
        preserveHistory: options.preserveHistory ?? true,
      };

      dispatch({ type: 'add', poll });
    },
    [dispatch]
  );

  const stopPoll = (pollId: string) => {
    dispatch({ type: 'remove', pollId });
  };

  return {
    startPoll,
    stopPoll,
  };
}
